import { useEffect, useRef, useState } from 'react'

const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)')

export function useCountUp(target: number, duration = 900): number {
  const [value, setValue] = useState(() => (reducedMotion.matches ? target : 0))
  const done = useRef(false)

  useEffect(() => {
    if (done.current || reducedMotion.matches) {
      setValue(target)
      return
    }
    done.current = true
    let frame: number
    const start = performance.now()
    const tick = (now: number) => {
      const t = Math.min(1, (now - start) / duration)
      const eased = 1 - (1 - t) ** 3
      setValue(target * eased)
      if (t < 1) frame = requestAnimationFrame(tick)
    }
    frame = requestAnimationFrame(tick)
    return () => cancelAnimationFrame(frame)
  }, [target, duration])

  return value
}
